import React from 'react'
import i18n from '../../lang/idiomas'
import ListadoArticulos from './ListadoArticulos'

const Novedades = () => {
  return (
    <div className='container'>
      <div id='tt-pageContent'>
        <div className='container-indent'>
          <h1 className='tt-title'>{i18n.t('articulos.titnov')}</h1>
          <div className='container-fluid-custom container-fluid-custom-mobile-padding'>
            <div className='row'>
              <div className='col-md-12 col-lg-12 col-xl-12'>
                <ListadoArticulos
                  mostrar='lista'
                  origen='novedades'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Novedades
